export default {
  translation: {
    "OrderList.Header.Title": "我的訂單清單",
      "OrderList.Input.Search": "訂單號碼...",
      "OrderList.Label.Status": "按Spocket狀態篩選",
  
      "order.status.unpaid": "未付款",
      "order.status.paid": "已付款",
      "order.status.processing": "處理中",
      "order.status.shipped": "已出貨",
      "order.status.cancelled": "已取消",
      "order.status.pending": "等候中",
      "order.status.partially_paid": "部分付款",
      "order.status.partially_refunded": "部分退款",
      "order.status.refunded": "已退款",
      "order.status.voided": "無效",
      "order.status.authorized": "已授權",
      "order.status.deleted": "已刪除",
      "order.status.pending_payment_confirmation": "等候中",
  
      "OrderList.Label.DownloadHistory": "下載所有訂單紀錄CSV",
      "OrderList.Document.Title": "訂單 - Spocket",
      "OrderList.EmptyOrders.Link.SearchProducts": "搜尋產品",
      "OrderList.EmptyOrders.Tip.HowToProcessOrders": "如何處理訂單",
      "OrderList.EmptyOrders.Message.Loading.Title": "正在載入您的訂單！",
      "OrderList.EmptyOrders.Message.Loading.Description": "請稍候，我們正在擷取您的訂單。",
      "OrderList.EmptyOrders.Message.Title": "您的訂單清單是空的！",
      "OrderList.EmptyOrders.Message.Description": "您可以在此處管理與處理您的訂單。前往搜尋頁面，開始將產品新增至您的導入清單。",
      "OrderList.CheckBox.SelectAllOrders": "選取所有訂單",
      "OrderList.CheckBox.SelectedXOrders": "已選取{{count}}筆訂單",
      "OrderList.CheckBox.SelectedXOrders_plural": "已選取{{count}}筆訂單",
      "OrderList.CheckBox.BulkCheckoutOrders": "大量結帳訂單",
      "OrderList.CheckBox.BulkCheckoutOrders_plural": "大量結帳訂單",
  
      "RefreshModal.Button.SynchronizeOrders": "同步訂單",
      "RefreshModal.Button.Cancel": "取消",
      "RefreshModal.Button.Synchronize": "同步",
      "RefreshModal.Modal.Body": "訂單會從您的商店自動同步。僅在缺少訂單資訊或尚未更新訂單資訊時才會進行同步。請您在30秒後重新整理頁面。",
  
      "Order.Label.OrderNumber" : "訂單號碼",
      "Order.Label.Date" : "日期",
      "Order.Label.OrderStatus" : "{{integrationName}}訂單狀態",
      "Order.Table.Th.Product" : "產品",
      "Order.Table.Th.Qty" : "數量",
      "Order.Table.Th.UnitPrice" : "單位價格",
      "Order.Table.Th.CheckoutDate" : "結帳日期",
      "Order.Table.Th.Action" : "動作",
  
      "CustomerModal.Button.ViewCustomerInfo": "查看客戶資訊",
      "CustomerModal.Modal.Title.CustomerInfo": "客戶資訊",
      "CustomerModal.Modal.Body.CustomerInfo": "客戶資訊",
      "CustomerModal.Modal.Body.Address": "地址",
  
      "OrderLine.Button.Checkout": "結帳",
      "OrderLine.Tooltip.PreviewInvoice": "預覽發票",
      "OrderLine.Tooltip.PaymentReceipt": "付款收據",
      "OrderLine.Tooltip.TrackOrder": "追蹤訂單",
      "OrderLine.Tooltip.OrderProcessing": "訂單處理",
      "OrderLine.Tooltip.OrderCancelled": "訂單已取消",
      "OrderLine.Tooltip.PleaseConfirm": "請點擊以確認您的訂單付款",
      "OrderLine.Label.PurchaseEtsy": "在Etsy購買",
      "OrderLine.Paying": "付款",
      "OrderLine.Failure": "失敗",
      "OrderLine.Sample": "樣品",
      "OrderLine.ErrorOrderRow": "無法在系統中找到已訂購的清單！請聯絡支援服務！",
  
      "ConfirmationModal.Label.OrderDetails": "訂單詳細資訊",
      "ConfirmationModal.Label.Total": "總計",
      "ConfirmationModal.Label.Shipping": "運送",
      "ConfirmationModal.Label.TransactionFees": "交易費用",
      "ConfirmationModal.Tooltip.TransactionFees": "交易費用包含Spocket的支付服務供應商Stripe收取的費用，以及服務費用。",
      "ConfirmationModal.Modal.OrderConfirmation": "訂單確認",
      "ConfirmationModal.Modal.Alert.Attention": "注意！",
      "ConfirmationModal.Modal.Alert.Description": "此訂單包含來自於客戶的備註。",
      "ConfirmationModal.Modal.YoureAboutToPlaceOrder": "您將要訂購，產品為",
      "ConfirmationModal.Modal.Table.Th.Name": "名稱",
      "ConfirmationModal.Modal.Table.Th.Price": "價格",
      "ConfirmationModal.Modal.Table.Th.Qty": "數量",
      "ConfirmationModal.Modal.Table.Th.Total": "總計",
      "ConfirmationModal.Modal.Label.Note": "給供應商的備註",
      "ConfirmationModal.Modal.PlaceHolder.Note": "您的訊息",
      "ConfirmationModal.Button.PlaceOrder": "下單",
  
      "PaymentCompleteModal.PaymentCompleted": "付款完成",
      "PaymentCompleteModal.PaymentCompleted.Note": "感謝您的付款。供應商已收到通知，並將立即處理訂單。我們將更新訂單狀態，並在您的訂單頁面新增追蹤號碼。",
      "PaymentCompleteModal.PaymentIncomplete": "您的訂單不完整！",
      "PaymentCompleteModal.PaymentIncomplete.BankRequiresConfirmation.Note": "您的銀行需要您確認付款才能繼續",
      "PaymentCompleteModal.PaymentIncomplete.ConfirmationLink": "請使用此鏈接確認付款。",
      "PaymentCompleteModal.PaymentIncomplete.Note": "確認付款後，供應商會收到通知，您的訂單將正常處理。狀態和追蹤更新將會新增至您的訂單頁面。請在確認後重新載入頁面。",
  
      "SetYourGoalsModal.Title": "新增至商店的產品數量",
      "SetYourGoalsModal.Subtitle": "一家典型的商店會在進行銷售之前推送25項產品",
      "SetYourGoalsModal.DropdownItem.Product": "{{count}}項產品",
      "SetYourGoalsModal.DropdownItem.Product_plural": "{{count}}項產品",
      "SetYourGoalsModal.Button": "設定我的目標，並開始直運（Dropshipping）",
  
      "YourGoalsBanner.Container.Description": "您的目標",
      "YourGoalsBanner.Header.Title": "開始您的業務",
      "YourGoalsBanner.Header.Subtitle": "讓您的商店做好準備",
      "YourGoalsBanner.Progress.Completed": "已完成",
      "YourGoalsBanner.ProductPushedCount": "&lt;0>目標：推送{{goalsNumberOfProduct}}&lt;/0>項產品",
      "YourGoalsBanner.CheckPoints.JoinSpocket": "加入Spocket",
      "YourGoalsBanner.CheckPoints.FirstSearch": "優先搜尋",
      "YourGoalsBanner.CheckPoints.ProductsPushed": "已推送{{count}} / {{goalsNumberOfProduct}}項產品",
      "YourGoalsBanner.CheckPoints.ProductsPushed_plural": "已推送{{count}} / {{goalsNumberOfProduct}}項產品",
      "YourGoalsBanner.CheckPoints.ProductsImported": "已導入{{count}} / {{goalsNumberOfProduct}}項產品",
      "YourGoalsBanner.CheckPoints.ProductsImported_plural": "已導入{{count}} / {{goalsNumberOfProduct}}項產品",
  
      "Plan.Starter" : "Starter",
      "Plan.Professional": "Professional",
      "Plan.Empire": "Empire",
      "Plan.Unicorn": "Unicorn",
  
      "Aliscraper.Title": "自動化AliExpress（全球速賣通）直運",
      "Aliscraper.Subtitle": "一鍵式將數以千計的AliExpress產品導入到您的電子商務店鋪，並且自動化您的直運業務。",
      "Aliscraper.Features.Feature1": "一鍵快速導入",
      "Aliscraper.Features.Feature2": "使用Spocket立即處理數以百計的產品",
      "Aliscraper.Features.Feature3": "全年無休的客戶支援",
      "Aliscraper.Button": "下載延伸套件",
      "Aliscraper.Chrome": "Chrome網路商店現已提供",
  
      "ConnectStoreModal.Header.Title": "連線您的商店",
      "ConnectStoreModal.Footer.Text": "選擇您要開始使用的平台",
      "ConnectStoreModal.ShopifyForm.UrlText": "Shopify商店網址",
      "ConnectStoreModal.ShopifyForm.InvalidName": "無效的商店名稱",
      "ConnectStoreModal.ShopifyForm.Placeholder": "例如：MyStore",
      "ConnectStoreModal.ShopifyForm.FooterText": "還沒有商店嗎？",
      "ConnectStoreModal.ShopifyForm.FooterLink": "免費試用",
      "ConnectStoreModal.ShopifyForm.Button": "連線商店",
      "ConnectStoreModal.WoocommerceInstruction.StoreIdText": "您的授權金鑰：",
      "ConnectStoreModal.WoocommerceInstruction.Intro": "如何將您的商店連線至Spocket：",
      "ConnectStoreModal.WoocommerceInstruction.Step1": "安裝Spocket外掛程式，從",
      "ConnectStoreModal.WoocommerceInstruction.Step1Link": "此處",
      "ConnectStoreModal.WoocommerceInstruction.Step2": "在您的外掛程式頁面啟動外掛程式",
      "ConnectStoreModal.WoocommerceInstruction.Step3": "前往WordPress控制台主頁 > Spocket",
      "ConnectStoreModal.WoocommerceInstruction.Step4": "貼上您的授權金鑰（如上方所列），並點擊「Save（儲存）」",
      "ConnectStoreModal.WoocommerceInstruction.Trouble": "有問題嗎？",
      "ConnectStoreModal.WoocommerceInstruction.TroubleLink": "請在此處聯絡我們",
      "ConnectStoreModal.WoocommerceInstruction.Button": "完成",
      "ConnectStoreModal.WixForm.FooterText": "還沒有商店嗎？",
      "ConnectStoreModal.WixForm.FooterLink": "免費試用",
      "ConnectStoreModal.WixForm.Button": "連線商店",
      "ConnectStoreModal.FelexForm.FooterText": "還沒有商店嗎？",
      "ConnectStoreModal.FelexForm.FooterLink": "免費試用",
      "ConnectStoreModal.FelexForm.Button": "連線商店",
      "ConnectStoreModal.BigcommerceForm.UrlText": "BigCommerce商店網址",
      "ConnectStoreModal.BigcommerceForm.InvalidName": "無效的商店名稱",
      "ConnectStoreModal.BigcommerceForm.Placeholder": "例如：MyStore",
      "ConnectStoreModal.BigcommerceForm.FooterText": "還沒有商店嗎？",
      "ConnectStoreModal.BigcommerceForm.FooterLink": "免費試用",
      "ConnectStoreModal.BigcommerceForm.Button": "連線商店",
  
      "PaymentTab.Document.Title": "設定 - 自動化 - Spocket",
      "PaymentTab.Title.Billing": "計費",
      "PaymentTab.Tooltip.Billing": "信用卡將用於訂單處理與訂購付款",
      "PaymentTab.AccordionItem.PauseChangeYourPlan": "暫停/變更您的方案",
      "PaymentTab.AccordionItem.Label.ChangeYourPlan": "變更您的方案",
      "PaymentTab.AccordionItem.Button.Downgrade": "降級",
      "PaymentTab.AccordionItem.Label.PauseYourPlan": "暫停您的方案",
      "PaymentTab.AccordionItem.Label.StoreHasBeenPaused": "您的商店之前已暫停",
      "PaymentTab.AccordionItem.Button.PauseYourPlan": "暫停您的方案",
      "PaymentTab.AccordionItem.Tooltip.PauseStore": "您可以暫停Spocket帳戶，之後可隨時恢復而不會遺失任何資料。",
      "PaymentTab.AccordionItem.Label.RemindMeLater": "稍後提醒我",
      "PaymentTab.AccordionItem.Button.RemindMeLater": "稍後提醒我",
      "PaymentTab.AccordionItem.Tooltip.RemindMeLater.3DaysBefore": "3天前",
      "PaymentTab.AccordionItem.Tooltip.RemindMeLater": "保留我的權益並在續訂前&lt;1>{{daysBefore}}&lt;/1>提醒我",
      "RemindMeLaterModal.Header.ReminderSet": "提醒設定",
      "RemindMeLaterModal.Body.DaysBefore": "在3天前寄送電子郵件給您",
      "RemindMeLaterModal.Body.ReminderSet": "您的提醒已設定，我們將在您的權益續訂前&lt;1>{{daysBefore}}&lt;/1>提醒您，在此之前，請繼續您的創業。",
      "RemindMeLaterModal.Button.Continue": "繼續",
      "PauseStoreModal.Title.PauseYourStore": "暫停您的商店",
      "PauseStoreModal.Description.PauseYourStore": "利用這個一次性優惠，在接下來的30天內降低70%的方案價格",
      "PauseStoreModal.Button.PauseStore": "暫停商店",
      "PauseStoreModal.Description.StorePaused": "您的商店已暫停，下個月的訂購金額將減少70%。請注意，之後將繼續定期付款。",
      "ConfirmPasswordModal.Title": "請確認您的密碼",
      "ConfirmPasswordModal.SubTitle": "基於安全原因，請確認您的密碼",
      "ConfirmPasswordModal.Input.Placeholder": "您的密碼",
      "ConfirmPasswordModal.Button.Cancel": "取消",
      "ConfirmPasswordModal.Button.Confirm": "確認",
  
      "Config.MomentJs.Locale":"zh-cn", 
      "Config.Plan.Starter":"Starter",
      "Config.Plan.Professional":"Pro",
      "Config.Plan.Empire":"Empire",
      "Config.Plan.Unicorn":"Unicorn",
  
      "UpgradeConfirmationModal.Header.Title":"借助Spocket實現更快發展 ", 
      "UpgradeConfirmationModal.Body.Title":"選擇您的計費週期",
      "UpgradeConfirmationModal.BulletPoints.Trial.Initial":"您的前",
      "UpgradeConfirmationModal.BulletPoints.Trial.BeforeNumber":"", 
      "UpgradeConfirmationModal.BulletPoints.Trial.AfterNumber":"天 ", 
      "UpgradeConfirmationModal.BulletPoints.Trial.Final":"為免費，請在試用期間或試用結束後取消",
      "UpgradeConfirmationModal.BulletPoints.FirstBill":"您的第一筆帳單將安排在",
      "UpgradeConfirmationModal.BulletPoints.FirstBillNoTrial":"您的第一筆帳單將在確認後到期",
      "UpgradeConfirmationModal.BulletPoints.Recurrence":"計費方式將按月循環",
      "UpgradeConfirmationModal.MonthlyTab.RateType":"每月 ", 
      "UpgradeConfirmationModal.MonthlyTab.RateFrequency":"/月",
      "UpgradeConfirmationModal.YearlyTab.RateType":"每年 ", 
      "UpgradeConfirmationModal.YearlyTab.RateFrequency":"/月",
      "UpgradeConfirmationModal.YearlyTab.Discount":"關閉",
      "UpgradeConfirmationModal.TaxRates.Text":"銷售稅",
      "UpgradeConfirmationModal.TaxRates.Period":"月",
      "UpgradeConfirmationModal.YearlyPanel.PayNow":"立即付款",
      "UpgradeConfirmationModal.YearlyPanel.PerMonth":"/月 X 12個月",
      "UpgradeConfirmationModal.YearlyPanel.Savings":"您節省的金額：", 
      "UpgradeConfirmationModal.YearlyPanel.Period":"/年",
      "UpgradeConfirmationModal.YearlyPanel.EquivalentInitial":"等於",
      "UpgradeConfirmationModal.YearlyPanel.EquivalentFinal":"%優惠",
      "UpgradeConfirmationModal.YearlyPanel.Warning.Trial":"年度方案沒有試用期",
      "UpgradeConfirmationModal.YearlyPanel.Warning.Charge":"將立即向您全額收費",
      "UpgradeConfirmationModal.CreditCardTab.Info":"使用信用卡/簽帳金融卡支付",
      "UpgradeConfirmationModal.PayPalTab.Info":"使用PayPal支付",
      "UpgradeConfirmationModal.PaymentSection.Details":"付款詳細資訊 ", 
      "UpgradeConfirmationModal.CheckoutButton.FreeTrial":"索取免費試用",
      "UpgradeConfirmationModal.CheckoutButton.Upgrade":"升級至 ", 
      "UpgradeConfirmationModal.FooterTestA.Info1.Top":"受到50,000多位企業家的信賴",
      "UpgradeConfirmationModal.FooterTestA.Info1.Bottom":"客戶始終給予我們5/5的評價。",
      "UpgradeConfirmationModal.FooterTestA.Info2.Top":"128位元SSL加密",
      "UpgradeConfirmationModal.FooterTestA.Info2.Bottom":"我們會100%保護您的付款詳細資訊。",
      "UpgradeConfirmationModal.FooterTestB.Avatars":"50,000多",
      "UpgradeConfirmationModal.FooterTestB.Info1.Top":"受到50,000多位企業家的信賴",
      "UpgradeConfirmationModal.FooterTestB.Info1.Bottom":"客戶始終給予我們5/5的評價。",
      "UpgradeConfirmationModal.FooterTestB.Info2.Top":"128位元SSL加密",
      "UpgradeConfirmationModal.FooterTestB.Info2.Bottom":"我們會100%保護您的付款詳細資訊。",
      "UpgradeConfirmationModal.Agreement.Intro":"如果繼續，即代表您同意 " , 
      "UpgradeConfirmationModal.Agreement.Terms":"使用條款",
      "UpgradeConfirmationModal.Agreement.Privacy":"隱私政策",
      "UpgradeConfirmationModal.Agreement.Refund":"退款政策",
      "UpgradeConfirmationModal.Agreement.Middle":"，與",
      "UpgradeConfirmationModal.Agreement.Cancelation":"取消政策",
  
      "CreditCard.Update.Label":"信用卡",
      "CreditCard.Update.InputValue":"信用卡尾號為",
      "CreditCard.Update.Button":"更新銀行卡",
      "CreditCard.AddCreditCard.Text":"您尚未新增任何的信用卡。請從下方的按鈕新增信用卡，以允許我們自動處理您的訂單",
      "CreditCard.AddCreditCard.Button":"新增信用卡",
  
      "Sidebar.SearchProducts":"搜尋產品",
      "Sidebar.WinningProducts":"暢銷產品",
      "Sidebar.WinningProducts.Variant":"新的",
      "Sidebar.ImportList":"導入清單",
      "Sidebar.MyProducts":"我的產品",
      "Sidebar.MyOrders":"我的訂單",
      "Sidebar.Apps":"應用程式",
      "Sidebar.HelpCenter":"說明中心",
      "Sidebar.MyShop":"我的商店",
      "Sidebar.Settings":"設定",
  
      "TutorialModal.Title":"我們在此協助您",
      "TutorialModal.WhatIsSpocket":"Spocket是什麼呢？",
      "TutorialModal.DiscoverProducts":"探索產品",
      "TutorialModal.ProductCustomization":"產品客製化",
      "TutorialModal.OrderProcessing":"訂單處理",
      "TutorialModal.Settings":"設定",
      "TutorialModal.GetHelp":"取得說明",
      "TutorialModal.JoinTheCommunity":"加入社群",
  
      "NotificationCenter.Header":"通知中心",
      "NotificationCenter.Footer":"查看所有通知",
      "NotificationCenter.NoNotification":"沒有任何內容！",
  
      "Products.Title.Head":"我的產品 - Spocket",
      "Products.Title.Header":"我的產品",
      "Products.Loading.Top":"正在載入您的產品清單！",
      "Products.Loading.Bottom":"請稍候，我們正在擷取您的產品。",
      "Products.Empty.Search":"找不到產品！",
      "Products.Empty.Top":"您的產品清單是空的！",
      "Products.Empty.Bottom":"前往搜尋頁面，開始將產品新增至您的導入清單。",
      "Products.Empty.Button.Search":"搜尋產品",
      "Products.Empty.Button.How":"如何尋找產品",
      "Products.Alert.Removed":"產品已移除",
  
      "Products.Search.Label":"搜尋您的產品",
      "Products.Search.Placeholder":"關鍵字",
      "Products.Search.Button":"搜尋",
  
      "ProductListItem.Inactive.Tooltip":"該供應商已不再提供此產品",
      "ProductListItem.Inactive.Title":"非使用中",
      "ProductListItem.OutOfStock.Tooltip":"此產品的所有款式皆已售罄",
      "ProductListItem.OutOfStock.Title":"缺貨",
      "ProductListItem.InventoryCount.Singular":"件",
      "ProductListItem.InventoryCount.Plural":"件",
      "ProductListItem.InventoryCount.End.Singular":"剩下",
      "ProductListItem.InventoryCount.End.Plural":"剩下",
      "ProductListItem.Button.View":"在商店查看",
      "ProductListItem.Button.Remove":"從商店移除",
  
      "ImportList.Title.Head":"導入清單 - Spocket", 
      "ImportList.Title.Header":"我的導入清單",
      "ImportList.Loading.Top":"正在載入您的導入清單！",
      "ImportList.Loading.Bottom":"請稍候，我們正在擷取您的產品。",
      "ImportList.Empty.Button.Search":"搜尋產品",
      "ImportList.Empty.Top":"您的導入清單是空的！",
      "ImportList.Empty.Bottom":"前往搜尋頁面，開始將產品新增至您的導入清單。",
      "ImportList.Empty.Button.How":"如何自訂產品",
      "ImportList.Alert.Pushed":"此產品已推送至您的商店：",
  
      "ImportList.Search.Label":"透過導入的產品進行搜尋",
      "ImportList.Search.Placeholder":"搜尋您的產品",
      "ImportList.Search.Button":"搜尋",
  
      "PushAllModal.Button.Active":"推送當前頁面產品",
      "PushAllModal.Button.Inactive":"推送當前頁面",
      "PushAllModal.Modal.Text":"您是否確定要從此當前頁面推送所有產品？所有在當前頁面的有效產品將會推送至您的商店。",
      "PushAllModal.Modal.Push":"推送全部",
      "PushAllModal.Modal.Cancel":"取消",
  
      "RemoveAllModal.Button.Active":"移除當前頁面產品",
      "RemoveAllModal.Button.Inactive":"移除當前頁面",
      "RemoveAllModal.Modal.Text":"您是否確定要從當前頁面移除所有產品？您當前頁面上的所有產品將從導入清單中移除。",
      "RemoveAllModal.Modal.Remove":"移除全部",
      "RemoveAllModal.Modal.Cancel":"取消",
  
      "ImportListItem.Tab.Product":"產品",
      "ImportListItem.Tab.Description":"說明",
      "ImportListItem.Tab.Variants":"款式",
      "ImportListItem.Tab.Images":"影像",
      "ImportListItem.Remove.Active":"移除產品",
      "ImportListItem.Remove.Inactive":"移除產品",
      "ImportListItem.Push.Active":"推送至商店",
      "ImportListItem.Push.Inactive":"推送至商店",
      "ImportListItem.Save.Button":"儲存",
      "ImportListItem.Alert.Removed":"此產品已經從您的導入清單中移除：",
      "ImportListItem.Alert.RemoveFailed":"嘗試移除時發生錯誤：",
      "ImportListItem.Alert.CompareAtPrice":"比較價格應該高於以下銷售價格：",
      "ImportListItem.Alert.OneActiveVariation":"此產品需要至少一項使用中的款式：",
      "ImportListItem.Alert.Saved":"已經儲存此產品：",
      "ImportListItem.Alert.ErrorPushing":"在推送至您的商店時發生錯誤",
      "ImportListItem.Alert.ErrorSaving":"儲存您的商店時發生錯誤",
      "ImportListItem.Modal.ConnectStore":"連線您的商店以推送產品：",
      "ImportListItem.Tooltip.OneActiveVariation":"您需要至少一項使用中的款式",
      "ImportListItem.Tooltip.Unavailable":"目前無法購買此產品",
      "ImportListItem.Tooltip.Unsaved":"您有尚未儲存的變更",
      "ImportListItem.Tooltip.Profit":"警告：此產品的毛利為負值",
      "ImportListItem.Tooltip.Unpurchasable":"您可以儲存此產品，但目前無法購買",
  
      "ItemInfo.ProductName.Label":"產品名稱",
      "ItemInfo.ProductTags.Label":"產品標籤",
      "ItemInfo.ProductTags.Remove":"移除全部標籤",
      "ItemInfo.ProductTags.Placeholder":"新增新的標籤",
      "ItemInfo.ProductType.Label":"產品類型",
      "ItemInfo.Collection.Label":"系列",
      "ItemInfo.Collection.Placeholder":"選取",
      "ItemInfo.Collection.Option":"選取",
  
      "ItemVariantList.Modal.Title":"運送詳細資訊",
      "ItemVariantList.Modal.Intro":"託運人：",
      "ItemVariantList.Modal.DoesNotShipInternational":"無法運送此品項到國外。",
      "ItemVariantList.Modal.DoesNotShipTo":"無法運送至以下地點：",
      "ItemVariantList.Table.Head.Destination":"目的地",
      "ItemVariantList.Table.Head.Cost":"費用",
      "ItemVariantList.Table.Head.Time":"運送時間（天數）",
      "ItemVariantList.Table.Body.Domestic":"國內",
      "ItemVariantList.Table.Body.International":"國際",
      "ItemVariantList.VariantsTable.ShippingPrice":"運送價格 ", 
      "ItemVariantList.VariantsTable.Image":"影像",
      "ItemVariantList.VariantsTable.SKU":"SKU",
      "ItemVariantList.VariantsTable.Inventory":"庫存",
      "ItemVariantList.VariantsTable.Price":"價格",
      "ItemVariantList.VariantsTable.SalesPrice":"銷售價格 ", 
      "ItemVariantList.VariantsTable.Profit":"利潤",
      "ItemVariantList.VariantsTable.CompareAtPrice":"比較價格",
      "ItemVariantList.VariantsTable.Unavailable":"目前無法購買此產品",
      "ItemVariantList.VariantsTable.Head":"此產品的所有款式皆顯示於此處。",
      "ItemVariantList.VariantsTable.ContextPopover.Placeholder":"例如：40%",
      "ItemVariantList.Alert.MaxVariants":"Shopify最多支援100種款式。",
  
      "ItemVariantList.ContextPopover.Title":"設定利潤",
      "ItemVariantList.ContextPopover.Apply":"套用",
  
      "ProductVariation.Description": "您可以直接在Spocket訂購樣品。請依循以下步驟，以便快速輕鬆地結帳。",
      "ProductVariation.Label.SelectVariant": "選取款式",
      "ProductVariation.Label.SelectTheProductVariation": "選取產品款式",
      "ProductVariation.Qty": "數量",
      "ProductVariation.Label.NotesForTheSupplier": "供應商注意事項",
  
      "InputAddress.Label.FirstName": "名字",
      "InputAddress.PlaceHolder.FirstName": "輸入名字",
      "InputAddress.Label.LastName": "姓氏",
      "InputAddress.PlaceHolder.LastName": "輸入姓氏",
      "InputAddress.Label.StreetAddress": "街道地址",
      "InputAddress.Label.Country": "國家",
      "InputAddress.PlaceHolder.Country": "搜尋國家",
      "InputAddress.Label.State": "州/省",
      "InputAddress.Placeholder.State": "搜尋州/省",
      "InputAddress.Label.City": "城市",
      "InputAddress.PlaceHolder.City": "輸入城市",
      "InputAddress.Label.Zip": "郵遞區號",
      "InputAddress.PlaceHolder.Zip": "輸入郵遞區號",
      "InputAddress.Label.Phone": "電話號碼",
      "InputAddress.Placeholder.Phone": "輸入電話號碼",
  
      "OrderReview.OrderDetails": "其他詳細資訊",
      "OrderReview.Unit": "{{count}}單位",
      "OrderReview.Unit_plural": "{{count}}個單位",
      "OrderReview.ShippingAddress": "運送地址",
      "OrderReview.PaymentMethod": "付款方式",
      "OrderReview.Amounts": "金額",
      "OrderReview.Subtotal": "小計",
      "OrderReview.ShippingCost": "運送費用",
      "OrderReview.TransactionFees": "交易費用",
      "OrderReview.TransactionFees.ToolTips": "交易費用包含Spocket的支付服務供應商Stripe收取的費用，以及服務費用。",
      "OrderReview.OrderTotal": "訂單總計",
      "OrderReview.ItemWithCount": "{{count}}個品項",
      "OrderReview.ItemWithCount_plural": "{{count}}個品項",
      "OrderReview.Placeholder.CreditCard": "信用卡尾號為{{last4}}",
  
      "PaymentComplete.PaymentCompleted": "付款完成",
      "PaymentComplete.PaymentCompleted.Note": "感謝您的付款。供應商已收到通知，並將立即處理訂單。我們將更新訂單狀態，並在您的訂單頁面新增追蹤號碼。",
      "PaymentComplete.PaymentIncomplete": "您的訂單不完整！",
      "PaymentComplete.PaymentIncomplete.BankRequiresConfirmation.Note": "您的銀行需要您確認付款才能繼續",
      "PaymentComplete.PaymentIncomplete.ConfirmationLink": "請使用此鏈接確認付款。",
      "PaymentComplete.PaymentIncomplete.Note": "確認付款後，供應商會收到通知，您的訂單將正常處理。狀態和追蹤更新將會新增至您的訂單頁面。請在確認後重新載入頁面。",
  
      "CreditCard.AddCreditCard.Description": "您尚未新增任何的信用卡。請從下方的按鈕新增信用卡，以允許我們自動處理您的訂單",
      "CreditCard.Button.AddCreditCard": "新增信用卡",
      "CreditCard.Button.UpdateCard": "更新銀行卡",
      "CreditCard.UpdateCard.Label.CreditCard": "信用卡",
      "CreditCard.PlaceHolder.CreditCard": "信用卡尾號為{{last4}}",
  
      "UpdateCreditCardModal.Label.CreditCard": "信用卡",
      "UpdateCreditCardModal.Button.UpdateCard": "更新銀行卡",
      "UpdateCreditCardModal.Button.AddCreditCard": "新增信用卡",
      "UpdateCreditCardModal.Button.Cancel": "取消",
      "UpdateCreditCardModal.Label.UpdateCardDetails": "更新您的銀行卡詳細資訊",
      "UpdateCreditCardModal.Label.TermsAndConditionsNote.One": "您的帳戶將會在Spocket產品訂單處理期間使用。",
      "UpdateCreditCardModal.Label.TermsAndConditionsNote.Two": "條款與條件",
      "UpdateCreditCardModal.Label.TermsAndConditionsNote.Three": "以處理付款。",
  
      "SampleOrderModal.Title.SelectVariation": "選取款式",
      "SampleOrderModal.Title.ShippingAddress": "運送地址",
      "SampleOrderModal.Title.PaymentMethod": "付款方式",
      "SampleOrderModal.Title.Review": "檢閱",
      "SampleOrderModal.Title.PaymentConfirmationRequired": "需要付款確認！",
      "SampleOrderModal.Title.OrderPlaced": "已經下單！",
      "SampleOrderModal.Steps": "步驟{{current}}，共{{total}}步驟",
      "SampleOrderModal.FinalStep": "最後步驟",
      "SampleOrderModal.ConfirmPayment": "確認付款！",
      "SampleOrderModal.Finished": "已完成",
      "SampleOrderModal.Footer.Continue": "繼續",
      "SampleOrderModal.Footer.PlaceOrder": "下單",
      "SampleOrderModal.Footer.Close": "關閉",
      "SampleOrderModal.Footer.Cancel": "取消",
      "SampleOrderModal.Footer.GoBack": "回到上一頁",
  
      "RatingCaptureModal.EnjoyingSpocket": "喜歡Spocket嗎？",
      "RatingCaptureModal.TapAStar": "在應用程式商店中點選星號評價",
  
      "AdvancedFiltersModal.Title.Filters": "篩選",
      "AdvancedFiltersModal.Title.Shipping": "運送",
      "AdvancedFiltersModal.Label.ShipsFrom": "託運人",
      "AdvancedFiltersModal.Label.ShipsTo": "收貨人",
      "AdvancedFiltersModal.Label.ShippingTime": "運送時間",
      "AdvancedFiltersModal.Label.Popular": "熱門",
      "AdvancedFiltersModal.Label.Country.UnitedStates": "美國",
      "AdvancedFiltersModal.Label.Country.Europe": "歐洲",
      "AdvancedFiltersModal.Label.ShippingTimeDescription": "僅提供運送至美國的服務",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Any": "任何天數",
      "AdvancedFiltersModal.RadioOption.ShippingTime.One": "1-3天",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Four": "4-7天",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Eight": "8-14天",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Fifteen": "15天以上",
      "AdvancedFiltersModal.Title.ItemsCost": "品項費用",
      "AdvancedFiltersModal.Label.ItemCost": "品項費用",
      "AdvancedFiltersModal.Label.ShippingCost": "運送費用",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Any": "任何費用",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Free": "免費",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Five": "$5及以下",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Fifteen": "$15及以下",
      "AdvancedFiltersModal.RadioOption.ShippingCost.TwentyFive": "$25及以下",
      "AdvancedFiltersModal.Title.Supplier": "供應商",
      "AdvancedFiltersModal.Select.MenuTitle.Suppliers": "供應商",
      "AdvancedFiltersModal.Label.TopSupplier": "熱門供應商",
      "AdvancedFiltersModal.Label.TopSupplierDescription": "供應商以其高品質產品、絕佳服務以及高評等的評論而聞名",
      "AdvancedFiltersModal.Title.Advanced": "進階",
      "AdvancedFiltersModal.Checkbox.Label.PremiumProducts": "優質產品",
      "AdvancedFiltersModal.Checkbox.Label.PremiumProductsDescription": "高折扣與快速運送的產品",
      "AdvancedFiltersModal.Checkbox.Label.BestSeller": "最佳賣家",
      "AdvancedFiltersModal.Checkbox.Label.BestSellerDescription": "Spocket上表現最佳產品",
      "AdvancedFiltersModal.Button.Cancel": "取消",
      "AdvancedFiltersModal.Button.ViewResults": "查看結果",
      "AdvancedFiltersModal.Select.PlaceHolder.Countries": "搜尋國家…",
      "AdvancedFiltersModal.Select.MenuTitle.Countries": "國家",
      "AdvancedFiltersModal.Select.PlaceHolder.Suppliers": "搜尋供應商…",
      "AdvancedFiltersModal.Label.All Suppliers": "所有供應商",
      "AdvancedFiltersModal.Label.New Suppliers": "新供應商",
  
      "AdvancedFilters.ShippingTime.Any": "任何天數",
      "AdvancedFilters.ShippingTime.One": "1-3天",
      "AdvancedFilters.ShippingTime.Four": "4-7天",
      "AdvancedFilters.ShippingTime.Eight": "8-14天",
      "AdvancedFilters.ShippingTime.Fifteen": "15天以上",
  
      "AdvancedFilters.ShippingCost.Free": "免費運送",
      "AdvancedFilters.ShippingCost.Five": "運費低於$5",
      "AdvancedFilters.ShippingCost.Fifteen": "運費低於$15",
      "AdvancedFilters.ShippingCost.TwentyFive": "運費低於$25",
  
      "AdvancedFilters.transpileFiltersKey.Label.ClearAll": "清除全部",
      "AdvancedFilters.transpileFiltersKey.Label.Shipping": "運送",
      "AdvancedFilters.transpileFiltersKey.Label.Keywords": "搜尋",
      "AdvancedFilters.transpileFiltersKey.Label.ShipsFrom": "託運人",
      "AdvancedFilters.transpileFiltersKey.Label.ShipsTo": "收貨人",
      "AdvancedFilters.transpileFiltersKey.Label.Supplier": "供應商",
      "AdvancedFilters.transpileFiltersKey.Label.SortBy": "排序方式",
      "AdvancedFilters.transpileFiltersKey.Label.ItemCost": "品項費用",
      "AdvancedFilters.transpileFiltersKey.Value.TopSuppliers": "熱門供應商",
      "AdvancedFilters.transpileFiltersKey.Value.PersonalizedInvoices": "個人化發票",
      "AdvancedFilters.transpileFiltersKey.Value.BestSeller": "最佳賣家",
      "AdvancedFilters.transpileFiltersKey.Value.Premium": "優質",
      "AdvancedFilters.transpileFiltersKey.Value.ItemCost.FromTo": "從{{from}}至{{to}}",
  
      "Search.Header.PlaceHolder.Search": "輸入關鍵字…",
      "Search.Header.Button.Search": "搜尋",
      "Search.Header.Button.Filters": "篩選",
  
      "Navigation.UpgradeButton.TryPro": "免費試用Spocket Pro",
      "Navigation.UpgradeButton.TryEmpire": "免費試用Spocket EMPIRE",
      "Navigation.UpgradeButton.TryUnicorn": "免費試用Spocket Unicorn",
  
      "CategoriesCards.Label.MoreCategories": "更多類別",
  
      "StaticCategories.WomensClothing": "女士衣著",
      "StaticCategories.WomensClothing.Activewear": "運動服飾",
      "StaticCategories.WomensClothing.Bodysuits": "連身衣",
      "StaticCategories.WomensClothing.Dresses": "洋裝",
      "StaticCategories.WomensClothing.JacketsCoats": "夾克與外套",
      "StaticCategories.WomensClothing.Jeans": "牛仔褲",
      "StaticCategories.WomensClothing.JumpsuitsRompers": "連身裙與連身褲",
      "StaticCategories.WomensClothing.Leggings": "緊身褲",
      "StaticCategories.WomensClothing.LingerieUnderwear": "內衣與內褲",
      "StaticCategories.WomensClothing.MatchingSets": "套裝",
      "StaticCategories.WomensClothing.Pants": "長褲",
      "StaticCategories.WomensClothing.Shorts": "短褲",
      "StaticCategories.WomensClothing.Skirts": "裙裝",
      "StaticCategories.WomensClothing.Sleepwear": "睡衣",
      "StaticCategories.WomensClothing.Socks": "襪子",
      "StaticCategories.WomensClothing.SweatersHoodies": "毛衣與連帽衫",
      "StaticCategories.WomensClothing.Swimwear": "泳衣",
      "StaticCategories.WomensClothing.TankTops": "坦克背心",
      "StaticCategories.WomensClothing.TopsBlouses": "上衣與襯衫",
      "StaticCategories.WomensClothing.Tshirts": "T恤",
  
      "StaticCategories.JewelryWatches": "珠寶與手錶",
      "StaticCategories.JewelryWatches.Bracelets": "手鍊",
      "StaticCategories.JewelryWatches.Earrings": "耳環",
      "StaticCategories.JewelryWatches.Necklaces": "項鍊",
      "StaticCategories.JewelryWatches.OtherAccessories": "其他飾品",
      "StaticCategories.JewelryWatches.PendantsStonesCharms": "掛飾、寶石與小綴飾",
      "StaticCategories.JewelryWatches.Rings": "戒指",
      "StaticCategories.JewelryWatches.Sets": "套組",
      "StaticCategories.JewelryWatches.Watches": "手錶",
  
      "StaticCategories.TechAccessories": "科技配件",
      "StaticCategories.TechAccessories.AudioVideo": "影音商品",
      "StaticCategories.TechAccessories.CasesCovers": "保護套與保護殼",
      "StaticCategories.TechAccessories.Lighting": "照明",
      "StaticCategories.TechAccessories.MobileLaptopAccessories": "手機與筆記型電腦配件",
      "StaticCategories.TechAccessories.Mousepads": "滑鼠墊",
      "StaticCategories.TechAccessories.Novelty": "創意商品",
  
      "StaticCategories.KidsBabies": "兒童與嬰兒",
      "StaticCategories.KidsBabies.BabyClothing": "嬰兒衣著",
      "StaticCategories.KidsBabies.Bathing": "沐浴",
      "StaticCategories.KidsBabies.BlanketsPillows": "毯子與枕頭",
      "StaticCategories.KidsBabies.CapsHeadbands": "帽子與頭巾",
      "StaticCategories.KidsBabies.Footwear": "鞋類",
      "StaticCategories.KidsBabies.Furniture": "家具",
      "StaticCategories.KidsBabies.KidsClothing": "兒童衣著",
      "StaticCategories.KidsBabies.ParenthoodAccessories": "育兒與配件",
  
      "StaticCategories.Toys": "玩具",
      "StaticCategories.Footwear": "鞋類",
      "StaticCategories.Footwear.Boots": "靴子",
      "StaticCategories.Footwear.Flats": "平底鞋",
      "StaticCategories.Footwear.Heels": "高跟鞋",
      "StaticCategories.Footwear.Mens": "男士",
      "StaticCategories.Footwear.Sandals": "涼鞋",
      "StaticCategories.Footwear.Slippers": "拖鞋",
      "StaticCategories.Footwear.SneakersRunners": "運動鞋與跑步鞋",
  
      "StaticCategories.BathBeauty": "沐浴與美妝",
      "StaticCategories.BathBeauty.Bodycare": "身體保養",
      "StaticCategories.BathBeauty.DiffusersOilsCandles": "擴香、精油與蠟燭",
      "StaticCategories.BathBeauty.Haircare": "護髮",
      "StaticCategories.BathBeauty.Healthcare": "保健",
      "StaticCategories.BathBeauty.Makeup": "化妝品",
      "StaticCategories.BathBeauty.Nails": "指甲",
      "StaticCategories.BathBeauty.Skincare": "皮膚保養",
      "StaticCategories.BathBeauty.TowelsRobes": "毛巾與長袍",
  
      "StaticCategories.Pets": "寵物",
      "StaticCategories.Pets.BedsBlankets": "寢具與毯子",
      "StaticCategories.Pets.LeashesCollarsPetwear": "牽繩、項圈與寵物服飾",
      "StaticCategories.Pets.Petcare": "寵物照護",
      "StaticCategories.Pets.Toys": "玩具",
  
      "StaticCategories.HomeGarden": "家居與庭園",
      "StaticCategories.HomeGarden.Bathroom": "浴廁",
      "StaticCategories.HomeGarden.Clocks": "時鐘",
      "StaticCategories.HomeGarden.Drinkware": "飲具",
      "StaticCategories.HomeGarden.FoodBeverage": "食物與飲料",
      "StaticCategories.HomeGarden.Furniture": "家具",
      "StaticCategories.HomeGarden.Garden": "庭園",
      "StaticCategories.HomeGarden.HomeDecor": "居家裝飾",
      "StaticCategories.HomeGarden.HomeImprovement": "居家修繕",
      "StaticCategories.HomeGarden.Kitchen": "廚房",
      "StaticCategories.HomeGarden.Lighting": "照明",
      "StaticCategories.HomeGarden.Organization": "收納",
      "StaticCategories.HomeGarden.StationeryCrafts": "文具與工藝品",
      "StaticCategories.HomeGarden.TextilesPillows": "織品與枕頭",
      "StaticCategories.HomeGarden.Tools": "工具",
  
      "StaticCategories.Accessories": "配件",
      "StaticCategories.Accessories.Belts": "皮帶",
      "StaticCategories.Accessories.Cufflinks": "袖扣",
      "StaticCategories.Accessories.Hats": "帽子",
      "StaticCategories.Accessories.Keychains": "鑰匙圈",
      "StaticCategories.Accessories.ScarvesBandanas": "圍巾與頭巾",
      "StaticCategories.Accessories.Sunglasses": "太陽眼鏡",
  
      "StaticCategories.MensClothing": "男士衣著",
      "StaticCategories.MensClothing.Activewear": "運動服飾",
      "StaticCategories.MensClothing.DressShirts": "正裝襯衫",
      "StaticCategories.MensClothing.JacketsCoats": "夾克與外套",
      "StaticCategories.MensClothing.Pants": "長褲",
      "StaticCategories.MensClothing.Shorts": "短褲",
      "StaticCategories.MensClothing.Socks": "襪子",
      "StaticCategories.MensClothing.SweatersHoodies": "毛衣與連帽衫",
      "StaticCategories.MensClothing.Swimwear": "泳衣",
      "StaticCategories.MensClothing.TankTops": "坦克背心",
      "StaticCategories.MensClothing.Tshirts": "T恤",
      "StaticCategories.MensClothing.Underwear": "內衣褲",
  
      "StaticCategories.SportsOutdoors": "運動與戶外",
      "StaticCategories.SportsOutdoors.Activewear": "運動服飾",
      "StaticCategories.SportsOutdoors.Biking": "單車",
      "StaticCategories.SportsOutdoors.Camping": "露營",
      "StaticCategories.SportsOutdoors.EquipmentAccessories": "裝備與配件",
      "StaticCategories.SportsOutdoors.Fishing": "釣魚",
  
      "StaticCategories.Gifts": "禮品",
      "StaticCategories.Gifts.Adults": "成人用品",
      "StaticCategories.Gifts.Funny": "趣味",
      "StaticCategories.Gifts.Mugs": "馬克杯",
      "StaticCategories.Gifts.Novelty": "創意商品",
      "StaticCategories.Gifts.Personalized": "個人化",
      "StaticCategories.Gifts.Religious": "宗教",
  
      "StaticCategories.Automotive": "自動化",
      "StaticCategories.BagsWallets": "包款與錢包",
      "StaticCategories.Seasonal": "季節性",
      "StaticCategories.Seasonal.Christmas": "聖誕節",
      "StaticCategories.Seasonal.FathersDay": "父親節",
      "StaticCategories.Seasonal.Halloween": "萬聖節",
      "StaticCategories.Seasonal.MothersDay": "母親節",
  
      "StaticCategories.FestivalsParties": "節日與派對",
      "StaticCategories.FestivalsParties.PartySupplies": "派對用品",
      "StaticCategories.FestivalsParties.Wedding": "婚禮",
  
      "QuickFilters.Label.ShipsFromUSA": "從美國出貨",
      "QuickFilters.Label.ShipsFromEU": "從歐盟出貨",
      "QuickFilters.Label.Premium": "優質",
      "QuickFilters.Label.FastUSAShipping": "快速美國運送",
      "QuickFilters.Label.Under5": "美國運費低於$5",
  
      "SortBy.Label.SortBy": "排序方式",
      "SortBy.DropDown.Item.Relevance": "關聯性",
      "SortBy.DropDown.Item.PriceLowToHigh": "價格：從低到高",
      "SortBy.DropDown.Item.PriceHighToLow": "價格：從高到低",
      "SortBy.DropDown.Item.Newest": "最新",
      "SortBy.DropDown.Item.ShippingTime": "運送時間",
  
      "Breadcrumb.Item.Home": "首頁",
      "Breadcrumb.Item.Search": "搜尋",
  
      "UpgradeModal.Modal.Title": "選取定價方案",
  
      "Plans.ToggleSection.Monthly": "每月",
      "Plans.ToggleSection.Yearly": "每年",
      "Plans.ToggleSection.DiscountInitial": "獲得高達",
      "Plans.ToggleSection.DiscountSingular": "月",
      "Plans.ToggleSection.DiscountPlural": "月",
      "Plans.ToggleSection.DiscountFinal": "關閉",
      "Plans.ProrationCost.TextInitial": "您目前正在支付",
      "Plans.ProrationCost.TextFinal": "/年。升級到Empire只需一個額外的",
  
      "Card.Title.PeriodSingular": "月",
      "Card.Title.PeriodPlural": "月",
      "Card.Title.Off": "關閉",
      "Card.DescriptionVariantType.Starter": "開始銷售",
      "Card.DescriptionVariantType.Professional": "促進銷售",
      "Card.DescriptionVariantType.Empire": "最大化銷售",
      "Card.DescriptionVariantType.Unicorn": "管理大規模銷售",
      "Card.DescriptionVariantType.Period": "月",
      "Card.DescriptionVariantType.PricePeriod": "{{value}}/月",
      // eslint-disable-next-line
      "Card.DescriptionVariantType.AnnualDescription": "每年以${{value}}計費",
      "Card.DescriptionVariantType.MonthlyDescription": "在{{value}}天的試用之後",
      "Card.DescriptionVariantType.CurrentPlan": "您的目前方案",
      "Card.DescriptionVariantType.AnnualButton.Starter": "立即開始",
      "Card.DescriptionVariantType.MonthlyButton.Starter": "免費試用",
      "Card.DescriptionVariantType.AnnualButton.Professional": "立即開始",
      "Card.DescriptionVariantType.MonthlyButton.Professional": "免費試用",
      "Card.DescriptionVariantType.AnnualButton.Empire": "立即開始",
      "Card.DescriptionVariantType.MonthlyButton.Empire": "免費試用",
      "Card.DescriptionVariantType.AnnualButton.Unicorn": "立即開始",
      "Card.DescriptionVariantType.MonthlyButton.Unicorn": "免費試用",
      "Card.DescriptionVariantType.UniqueProducts": "獨特產品",
      "Card.DescriptionVariantType.PremiumProducts": "優質產品",
      "Card.DescriptionVariantType.EmailSupport": "電子郵件支援",
      "Card.DescriptionVariantType.Invoicing": "品牌發票",
      "Card.DescriptionVariantType.InvoicingTooltip": "從提供品牌發票的供應商，將您的商標加入所有訂單，即可建立您的品牌",
      "Card.DescriptionVariantType.ChatSupport": "聊天支援",
      "Card.DescriptionVariantType.WinningProducts": "暢銷產品",
      "Card.DescriptionVariantType.SupplierSourcing": "尋找供應商",
      "Card.DescriptionVariantType.ProductRequests": "產品請求",
      "Card.DescriptionVariantType.ProductRequestsTooltip": "請求尚未在Spocket出售的產品",
      "Card.DescriptionVariantType.BulkCheckout": "大量結帳",
      "Card.DescriptionVariantType.BulkCheckoutTooltip": "點擊按鈕即可一次為多筆訂單結帳",
      "Card.DescriptionVariantType.Special": "特殊",
  
      "ReactivationBanner.Alert": "您的Spocket訂購已結束。",
      "ReactivationBanner.InfoSubtitle": "重新啟動您的",
      "ReactivationBanner.CheckList.HighQuality": "高品質",
      "ReactivationBanner.CheckList.Curated": "已規劃",
      "ReactivationBanner.CheckList.FastShipping": "快速運送",
      "ReactivationBanner.CheckList.FromUSAndEU": "從美國和歐盟",
      "ReactivationBanner.TextByPlan.Starter.Description": "您將無法再&lt;1>推送任何產品&lt;/1>",
      "ReactivationBanner.TextByPlan.Starter.Title": "Spocket帳戶",
      "ReactivationBanner.TextByPlan.Starter.Subtitle": "立即開始將產品推送到您的商店",
      "ReactivationBanner.TextByPlan.Others.Description.PartOne": "您無法即時或使用&lt;1>推送產品&lt;/1> ",
      "ReactivationBanner.TextByPlan.Others.Description.PartTwo": "優質產品",
      "ReactivationBanner.TextByPlan.Others.Title": "優質帳戶",
      "ReactivationBanner.TextByPlan.Others.Subtitle": "存取優質產品",
      "ReactivationBanner.Button": "立即重新啟動我的帳戶",
  
      "AnnualPromotionModal.Header": "恭喜，您現在加入{{planName}}方案",
      "AnnualPromotionModal.CountdownTitle": "結束於",
      "AnnualPromotionModal.Button.Yes": "升級至年度",
      "AnnualPromotionModal.Button.No": "不，請繼續我的每月訂購方案",
  
      "UpgradeReasonModal.Benefits.IncreasedProducts": "更多產品推送",
      "UpgradeReasonModal.Benefits.UnlimitedOrders": "無限訂單",
      "UpgradeReasonModal.Benefits.BrandedInvoicing": "品牌發票",
      "UpgradeReasonModal.Benefits.PremiumProducts": "優質產品",
      "UpgradeReasonModal.Benefits.ExclusiveDeals": "獨家交易",
      "UpgradeReasonModal.Benefits.ChatCallSupport": "聊天與電話支援",
      "UpgradeReasonModal.Modal.Title": "您想通過Spocket實現什麼？",
      "UpgradeReasonModal.Modal.Question": "是什麼讓您升級？",
      "UpgradeReasonModal.Modal.Button": "開始使用Spocket{{plan}}",
      "UpgradeReasonModal.UpgradeComment.PlaceHolder": "這能夠幫助我們改善您的體驗",
  
      "UpgradeSuccessModal.Col.One.A": "恭喜。",
      "UpgradeSuccessModal.Col.One.B": "您現在加入{{alias}}方案！",
      "UpgradeSuccessModal.Col.Two.A": "您已經解鎖了需要用來建立成功直送業務的所有工具。",
      "UpgradeSuccessModal.Col.Two.B": "您現在可以擁有 ",
      "UpgradeSuccessModal.Col.Two.C": " 快樂使用Spoket！",
      "UpgradeSuccessModal.Button": "繼續",
  
      "Promotion.TrialDaysNormalizer.30days": "１個月",
      "Promotion.TrialDaysNormalizer.28days": "4週",
      "Promotion.TrialDaysNormalizer.21days": "3週",
      "Promotion.TrialDaysNormalizer.14days": "2週",
      "Promotion.TrialDaysNormalizer.7days": "1週",
      "Promotion.TrialDaysNormalizer.1day": "1天",
      "Promotion.TrialDaysNormalizer.Days": "{{value}}天",
      "Promotion.TrialDaysPlan.Title": "立即嘗試Spocket Pro並免費使用2週！",
      "Promotion.TrialDaysPlan.Text": "立即嘗試Spocket Pro並免費使用{{value}}！",
      "Promotion.Button": "免費試用",
      "StickyPromotion.Text": "免費試用Spocket Pro",
      "StickyPromotion.Button": "立即試用→",
      "Onboarding.Steps.Title": "促進您的商店銷售！",
      "Onboarding.Steps.Subtitle": "Spocket小秘訣：一家典型的商店會在進行銷售之前推送25項產品",
      "Steps.ChecklistItem.Connect.Text": "連線您的帳戶",
      "Steps.ChecklistItem.Connect.Tooltip": "將您的帳戶連線至您的Shopify或WooCommerce商店",
      "Steps.ChecklistItem.Connect.Disabled": "",
      "Steps.ChecklistItem.Search.Text": "搜尋產品並新增至導入清單",
      "Steps.ChecklistItem.Search.Tooltip": "從位在美國/歐盟的供應商那裡尋找絕佳產品，並將這些產品新增到您的導入清單。",
      "Steps.ChecklistItem.Search.Disabled": "",
      "Steps.ChecklistItem.Push.Text": "將商品推送到您的商店",
      "Steps.ChecklistItem.Push.Tooltip": "個人化導入清單中的產品，並一鍵式將其推送到您的商店。",
      "Steps.ChecklistItem.Push.Disabled": "",
      "Steps.ChecklistItem.Review.Text": "給Spotcket一個評論吧！",
      "Steps.ChecklistItem.Review.Tooltip": "喜歡您目前的體驗嗎？分享給其他人吧！",
      "Steps.ChecklistItem.Review.Disabled": "連線帳戶",
  
      "BubbleWidget.Head.Title":"您好",
      "BubbleWidget.Head.Subtitle":"歡迎來到Spocket支援",
      "BubbleWidget.HelpCenter.Title":"說明中心",
      "BubbleWidget.HelpCenter.Subtitle":"來自Spocket團隊的建議與答案",
      "BubbleWidget.EmailUs.Title":"寄送電子郵件給我們",
      "BubbleWidget.EmailUs.Subtitle":"請向我們提出您的問題",
      "BubbleWidget.ChatWithUs.Title":"與我們聊天",
      "BubbleWidget.ChatWithUs.Subtitle.Basic":"針對Pro與Empire用戶",
      "BubbleWidget.ChatWithUs.Subtitle.NotBasic":"我們的支援專員正在等候",
      "BubbleWidget.ChatWithUs.Subtitle.Unlock":"立即解鎖",
      "BubbleWidget.Community.Title":"社群",
      "BubbleWidget.Community.Subtitle":"加入擁有50,000多家直運商社群",
      "BubbleWidget.StoreReviews.Title":"商店評論",
      "BubbleWidget.StoreReviews.Subtitle":"Pro與Empire用戶",
      "BubbleWidget.StoreReviews.Unlock":"立即解鎖",
      "Language.Title": "語言",
  
      "sidebar.menu.search_product": "搜尋產品",
      "sidebar.menu.import_list": "導入清單",
      "plans_cards.card": "開始銷售",
      "plans_cards.card.starter.price": "&lt;1>{{currency_symbol}}&lt;/1>",
  
      "WhatYouWillLoseModal.Button.Offer": "繼續下去",
      "WhatYouWillLoseModal.Button.Downgrade": "我放棄了，請將我的帳戶降級",
      "WhatYouWillLoseModal.ProductSection.Title": "您將會失去所有&lt;1>{{product_count}}項導入產品&lt;/1>",
      "WhatYouWillLoseModal.Product.PremiumTag": "優質",
      "WhatYouWillLoseModal.Product.SkeletonImage": "再加{{product_count}}項",
      "WhatYouWillLoseModal.ModalWrapper.Header": "您已經放棄了嗎？",
      "WhatYouWillLoseModal.ModalWrapper.Title.Tag": "獲取5折的折扣",
      "WhatYouWillLoseModal.ModalWrapper.Title": "在未來3個月繼續您的創業。",
      "WhatYouWillLoseModal.ModalWrapper.Subtitle": "我們希望您成為另一個成功故事。我們知道您已經投入了大量時間。因此，繼續下去。我們都會支援您。Spocket團隊",
  
      "FiftyOff3MonthsOfferSuccessModal.Header": "恭喜，我們已經將未來3個月的5折優惠新增至您的方案！",
      "FiftyOff3MonthsOfferSuccessModal.Button": "繼續",
  
      "DowngradeReasonModal.DowngradeSection": "我們要如何讓Spocket為您做得更多？",
      "DowngradeReasonModal.DowngradeSection.TextArea.PlaceHolder": "我們希望能得到您對於每一件事情的回饋意見（最少100個字元）",
      "DowngradeReasonModal.DowngradeSection.Tooltip": "請輸入您的回饋意見（最少100個字元）",
      "DowngradeReasonModal.Button.Downgrade": "降級",
      "DowngradeReasonModal.ModalWrapper.Header": "是否要降級{{storeName}}？",
      "DowngradeReasonModal.ModalWrapper.ContactUs": "聯絡我們",
      "DowngradeReasonModal.ModalWrapper.Footer.Button.Cancel": "取消",
  
      "DowngradeSuccessModal.Header": "降級成功",
      "DowngradeSuccessModal.Body": "感謝您的回饋意見。我們每天都在不斷地改善Spocket，希望您能盡快再次給予我們一個機會！",
  
      "Settings.title": "設定",
      "Settings.buttonSaveChanges": "儲存變更",
      "Settings.buttonSaveAndPreview": "儲存與預覽",
  
      "AccountTab.documentTitle": "設定 - 帳戶 - Spocket",
      "AccountTab.title": "帳戶設定",
      "AccountTab.shopName": "商店名稱",
      "AccountTab.email": "電子郵件",
      "AccountTab.shopUrl": "商店網址",
      "AccountTab.defaultCurrency": "預設貨幣",
      "AccountTab.yourPlan": "您的方案",
      "AccountTab.accountNotActive": "您的帳戶目前無效",
      "AccountTab.alertFeatureWillBeAddedSoon": "即將新增此功能！現在，請透過Spocket Shopify應用程式連線！",
      "AccountTab.alertAccountSettingsUpdated": "帳戶設定已更新",
      "AccountTab.alertInvalidShopUrl": "無效的商店網址",
      "AccountTab.productsImported": "產品已導入",
      "AccountTab.products": "產品",
      "AccountTab.premiumProducts": "優質產品",
      "AccountTab.total": "總計",
      "AccountTab.signOut": "登出",
      "AccountTab.limitReachedProductsAndPremium": "已達到產品與優質產品限制。",
      "AccountTab.limitReachedProducts": "已達到產品限制。",
      "AccountTab.limitReachedPremium": "已達到優質產品限制。",
      "AccountTab.buttonSwitchToAnnualPlan": "切換為年度方案",
      "AccountTab.off30Percent": "7折",
      "AccountTab.off40Percent": "6折",
      "AccountTab.off45Percent": "55折",
      "AccountTab.sellMoreWithEmpirePlan": "搭配Empire方案，出售更多商品",
      "AccountTab.tooltipCurrency":"您的貨幣是透過您的商店帳戶管理。您導入產品的所有價格將會以該貨幣進行轉換。",
      "AccountTab.shopNotConnectedYet": "您的商店尚未連線至此帳戶。",
      "AccountTab.connectYourShop": "連線您的商店",
  
      "InvoiceTab.documentTitle": "設定 - 發票 - Spocket",
      "InvoiceTab.alertInvoiceSettingSaved": "已儲存發票設定！",
      "InvoiceTab.shopLogo": "商店商標",
      "InvoiceTab.contactEmail": "聯絡人電子郵件",
      "InvoiceTab.phoneNumber": "電話號碼",
      "InvoiceTab.personalNote": "個人備註",
      "InvoiceTab.tooltipPersonalNote": "設定個人備註，並在每一張品牌發票中加入此個人備註",
      "InvoiceTab.brandedInvoicing": "品牌發票",
      "InvoiceTab.tooltipBrandedInvoicing": "從使用付費方案提供品牌發票的供應商，將您的品牌商標與個人備註加入所有訂單",
      "InvoiceTab.disabledInvoicing": "在所有訂單上包含品牌發票",
      "InvoiceTab.tooltipDisabledInvoicing": "關閉此選項將會在您下單時排除品牌發票",
  
      "PricingTab.titleDefaultPricingRules": "預設定價規則",
      "PricingTab.tooltipTitleDefaultPricingRules": "您可以在此處指定一個固定的加成或乘數，套用於您的所有產品",
      "PricingTab.titleAdvancedPricingRules": "進階定價規則",
      "PricingTab.tooltipTitleAdvancedPricingRules": "進階規則任您能夠根據產品價格範圍設定您的加成或乘數。",
      "PricingTab.assignCents": "指定分值",
      "PricingTab.tooltipAssignCents": "此數值將用於顯示品項的最後價格（例如，假設您希望產品的成本為xx.99，則在下方的欄位填入99）。",
      "PricingTab.Markup": "加成",
      "PricingTab.MarkupType": "加成類型",
      "PricingTab.SelectDefault": "- 選取一項 --",
      "PricingTab.SelectPercent": "百分比",
      "PricingTab.SelectMultiplier": "乘數",
      "PricingTab.SelectFixed": "固定",
      "PricingTab.titlePricingRules": "設定 - 定價規則 - Spocket",
      "PricingTab.toggleAdvancedPricingRules": "切換進階定價規則",
      "PricingTab.from": "從",
      "PricingTab.to": "至",
      "PricingTab.selectFixedAmount": "固定金額",
      "PricingTab.buttonRemove": "移除",
      "PricingTab.alertCannotCreateMoreThanOneRuleWithEmptyFields": "您無法使用空白欄位建立多項規則",
      "PricingTab.costRange": "成本範圍",
      "PricingTab.markup": "加成",
      "PricingTab.add": "新增",
  
      "SecurityTab.Document.Title": "設定 - 安全性 - Spocket",
      "SecurityTab.alertIncorrectPassword": "不正確的密碼",
      "SecurityTab.title": "安全性",
      "SecurityTab.yourNewPassword": "您的新密碼",
      "SecurityTab.repeatPassword": "確認密碼",
      "SecurityTab.errorPleaseEnterAPassword": "請輸入密碼。",
      "SecurityTab.errorPasswordsConfirmationNeeded": "請輸入密碼確認。",
      "SecurityTab.errorPasswordsDoNotMatch": "密碼不相符",
      "SecurityTab.errorPasswordShort": "密碼長度必須為8個或8個以上字元",
  
      "currency_symbol": "$",
  
      "ListingCards.TopSupplierTag.Tooltip": "熱門供應商以其高品質產品、絕佳服務以及高評等而聞名",
      "ListingCards.TopSupplierTag.Text": "供應商",
  
      "ListingCard.OriginCountry.Intro":"由",
      "ListingCard.OriginCountry.Tooltip":"託運人",
      "ListingCard.Shipping.Price.Title":"運送價格",
      "ListingCard.Shipping.Price.Free":"免費",
      "ListingCard.Price.Intro":"價格",
      "ListingCard.Price.Retail":"零售價格",
      "ListingCard.Shipping.Time.Title":"運送時間",
      "ListingCard.Shipping.Time.Period":"天",
      "ListingCard.PremiumIcon.Tooltip":"在您的商店銷售獨家、高折扣與快速出貨的產品",
      "ListingCard.PremiumIcon.Text":"優質",
      "ListingCard.ListButton.Import":"新增至導入清單",
      "ListingCard.ListButton.Remove":"從導入清單中移除",
      "ListingCard.ListButton.Pushed":"已推送至商店",
  
      "ListingModal.MainSection.Title":"產品說明",
      "ListingModal.DetailsSection.Button.ProductVariations":"開啟產品款式",
      "ListingModal.DetailsSection.Button.OrderSamples":"訂購樣品",
      "ListingModal.DetailsSection.Button.OrderSamples.New":"新的",
      "ListingModal.DetailsSection.BrandedInvoicing.Alert":"品牌發票不適用於此產品",
      "ListingModal.DetailsSection.InternationalShipping.Alert":"國際訂單將從我們在中國的倉庫出貨",
      "ListingModal.DetailsSection.StockUsa.Alert":"在美國倉庫中缺貨的品項，可能會從我們的在中國的倉庫寄送",
      "ListingModal.DetailsSection.MultiplePackage.Alert":"訂單可能會以多個包裹寄送，以助於減少訂單的整體運送時間",
      "ListingModal.DetailsSection.ConnectStore.Alert":"連線至您的商店來下訂單",
      "ListingModal.DetailsSection.PushedListButton":"已推送至商店",
      "ListingModal.DetailsSection.RemoveListButton":"從清單移除",
      "ListingModal.DetailsSection.ImportListButton":"新增至導入清單",
      "ListingModal.DetailsSection.ImportListButton.Deactivated":"清單已停用",
  
      "InfoSection.ShippingTime.Tooltip": "出貨後運送產品的天數。",
      "InfoSection.ShippingTime.Title": "運送時間",
      "InfoSection.ShippingInfo.Worldwide": "全球",
      "InfoSection.ShippingExcluded.Intro": "無法運送至",
      "InfoSection.ShippingExcluded.Various": "各種",
      "InfoSection.ProcessingTime.Tooltip": "供應商運送的工作天數與提供追蹤號碼",
      "InfoSection.ProcessingTime.Title": "處理時間",
      "InfoSection.ProcessingTime.Period": "工作天數",
      "InfoSection.ShippingInfoLine.Tooltip": "此產品的運費為{{price_formatted}}，在相同訂單中，每增加一項額外產品，則加{{incremental_price_formatted}}",
      "InfoSection.ShippingInfoLine.Period": "工作天數",
      "InfoSection.ShippingInfoLine.Free": "免費",
      "InfoSection.ShippingInfoLine.NoShipping": "無法運送",
  
      "ReturnPolicySection.Title": "退貨政策",
  
      "TitleSection.TitleCountryOrigin.CountryOrigin.Intro": "從",
      "TitleSection.TitleCountryOrigin.SupplierShopName.Intro": "由",
      "TitleSection.PriceMSRP.Listing": "建議售價",
      "TitleSection.PriceMSRP.Retail": "零售價格",
  
      "ProductVariationsModal.Title": "產品款式",
      "ProductVariationsModal.Table.Image": "影像",
      "ProductVariationsModal.Table.Inventory": "庫存",
      "ProductVariationsModal.Table.Price": "價格",
      "ProductVariationsModal.ImageSpecifications.Title": "尺寸表",
      "ProductVariationsModal.ImageSpecifications.Button": "下載",
  
      "TopSupplier.Tooltip": "熱門供應商以其高品質產品、絕佳服務以及高評等而聞名",
      "TopSupplier.Text": "熱門供應商",
  
      "BestSelling.SharedComponents.Text": "暢銷產品",
      "BestSelling.Tooltip.Top": "這是在Spocket的最佳表現產品",
      "BestSelling.Tooltip.Bottom": "最佳賣家",
  
      "GallerySection.PremiumIcon.Tooltip": "在您的商店銷售獨家、高折扣與快速出貨的產品",
      "GallerySection.PremiumIcon.Text": "優質",
      "GallerySection.DiscountStamp.Text": "額外的{{value}}%優惠",
  
      "Upgrade.Title.AnnualToggled": "立即取得Spocket Premium",
      "Upgrade.Title.MonthlyToggled": "免費試用Spocket Premium 14天",
      "Upgrade.Subtitle": "立即試用Spocket Premium方案，並開始從美國和歐洲將熱銷產品新增到您的商店。",
      "Upgrade.Button": "不使用Spocket Premium並繼續",
  
      "Search.NoProductsFound.Title": "抱歉！我們無法找到任何結果",
      "Search.NoProductsFound.For": "對於",
      "Search.NoProductsFound.Description": "請檢查拼寫、嘗試相關的搜尋詞語或更通用的搜尋詞語。",
      "Search.Searching.Title": "我們正在搜尋產品...",
      "Search.Searching.Description": "請稍候，我們將為您載入最新產品。",
  
      "Suppliers.StarRating.Tooltip": "供應商訂單履行成功率",
      "Suppliers.RefundPolicy": "供應商的退貨政策",
      "Suppliers.Joined.Title": "已加入Spocket",
      "Suppliers.Origin.Title": "出貨國家",
      "Suppliers.Time.Title": "平均運送時間",
      "Suppliers.HasMore.Title": "我們正在搜尋產品...",
      "Suppliers.HasMore.Subtitle": "請稍候，我們將為您載入最新產品。",
      "Suppliers.TopSupplierTag.Tooltip": "熱門供應商以其高品質產品、絕佳服務以及高評等而聞名",
      "Suppliers.TopSupplierTag.Text": "熱門供應商",
  
      "AltTextModal.Header.Title": "編輯影像詳細資訊",
      "AltTextModal.Body.Description": "請輸入此影像的簡短說明，以改善搜尋引擎最佳化（SEO）並為視力受損客戶改善輔助使用。",
      "AltTextModal.Input.Label": "替代文字",
      "AltTextModal.Input.Placeholder": "影像替代文字",
      "AltTextModal.Button.Cancel": "取消",
      "AltTextModal.Button.Save": "儲存",
  
      "WistiaModal.WhatIsSpocket.Title": "Spocket是什麼呢？",
      "WistiaModal.WhatIsSpocket.Text": "了解Spocket如何協助您建立業務。了解Spocket的運作方式，以及您可以充分利用Spocket的方法。",
      "WistiaModal.WhatIsSpocket.Button": "開始尋找產品",
      "WistiaModal.DiscoverProducts.Title": "探索產品",
      "WistiaModal.DiscoverProducts.Text": "採用合適的篩選條件，找尋正確的產品，並將這些產品新增到您的商店。",
      "WistiaModal.DiscoverProducts.Button": "開始尋找產品",
      "WistiaModal.ProductCustomization.Title": "自訂您的產品",
      "WistiaModal.ProductCustomization.Text": "使用導入清單來修改您的產品，以適合您的商店。您可以編輯產品說明、設定價格、將產品新增到產品系列以及移除影像。",
      "WistiaModal.ProductCustomization.Button": "前往導入清單",
      "WistiaModal.OrderProcessing.Title": "自動化訂單處理",
      "WistiaModal.OrderProcessing.Text": "履行您的訂單，讓供應商一鍵將產品直接運送到客戶家門口。",
      "WistiaModal.OrderProcessing.Button": "前往訂單",
      "WistiaModal.Settings.Title": "設定",
      "WistiaModal.Settings.Text": "設定頁面可讓您管理所有的帳戶資訊、將品牌放上發票並且新增您的信用卡。您也可以為所有的產品調整定價規則，並選擇訂購方案。",
      "WistiaModal.Settings.Button": "設定您的帳戶"
  }
};



// WEBPACK FOOTER //
// ./src/utils/i18n/zh.js